'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Component2 = require('../../../Component');

var _Component3 = _interopRequireDefault(_Component2);

var _alert = require('../../templates/content/alert');

var _alert2 = _interopRequireDefault(_alert);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _theme = require('../../../theme');

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AlertBase = function (_Component) {
    _inherits(AlertBase, _Component);

    function AlertBase() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, AlertBase);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = AlertBase.__proto__ || Object.getPrototypeOf(AlertBase)).call.apply(_ref, [this].concat(args))), _this), _this.template = _alert2.default, _this.submit = function () {
            var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

            if (event.nativeEvent) {
                event.preventDefault();
                event.stopPropagation();
            }

            if (typeof _this.props.onSubmit === 'function') {
                _this.props.onSubmit();
            }
        }, _temp), _possibleConstructorReturn(_this, _ret);
    }

    _createClass(AlertBase, [{
        key: 'compileStyleHash',
        value: function compileStyleHash() {
            return _get(AlertBase.prototype.__proto__ || Object.getPrototypeOf(AlertBase.prototype), 'compileStyleHash', this).call(this) + String(this.props.closeAvailable);
        }
    }]);

    return AlertBase;
}(_Component3.default);

AlertBase.defaultProps = {
    needTitle: true,
    title: 'ALERT_INFO_TITLE',
    buttonLabel: 'ALERT_CONFIRM',
    closeAvailable: true
};
AlertBase.propTypes = {
    closeAvailable: _propTypes2.default.bool,
    needTitle: _propTypes2.default.bool,
    title: _propTypes2.default.string,
    buttonLabel: _propTypes2.default.string,
    className: _propTypes2.default.string,
    onSubmit: _propTypes2.default.func
};
AlertBase.displayName = 'AlertBase';
exports.default = (0, _theme2.default)(AlertBase, 'alertModal');